var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add_box"},[_c('card-number',{attrs:{"come":"add","mustImg":_vm.mustImg},on:{"inputChange":_vm.inputChange}}),_c('common-footer',{attrs:{"text":"添加","canClick":_vm.canClick},on:{"btnClick":_vm.btnClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }